<div class="modal-header">
    <h4>
        New Service Item
    </h4>
</div>
<div class="modal-body">
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Service Item <span style="color:red;">*</span></label><br />
        <input type="text" class="form-control" [(ngModel)]="formData.ServiceItem" style="max-width:300px;" [required]="formData.ServiceItem == null || formData.ServiceItem == ''"
               [ngClass]="{'is-invalid': formData.ServiceItem == null || formData.ServiceItem == ''}" maxlength="20" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Item Description</label><br />
        <input type="text" class="form-control" [(ngModel)]="formData.ItemDescription" style="max-width:300px;" maxlength="120" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Summary</label><br />
        <input type="text" class="form-control" [(ngModel)]="formData.ServiceItemSummary" style="max-width:300px;" maxlength="120" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Manufacturer</label><br />
        <input type="text" class="form-control" [(ngModel)]="formData.Manufacturer" style="max-width:300px;" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Model</label><br />
        <input type="text" class="form-control" [(ngModel)]="formData.Model" style="max-width:300px;" maxlength="60" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Year Manufactured</label><br />
        <input type="number" class="form-control" [(ngModel)]="formData.YearManufactured" style="max-width:300px;" maxlength="4" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Location</label><br />
        <input type="text" class="form-control" [(ngModel)]="formData.Location" style="max-width:300px;" maxlength="60" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Class Type <span style="color:red;">*</span></label><br />
        <ng-select [items]="lookupList['ItemClassType']"
                   [(ngModel)]="formData.SMTypeID"
                   [required]="formData.SMTypeID == null" 
                   [ngClass]="{'invalidui': formData.SMTypeID == null}"
                   bindLabel="CodeDescription"
                   bindValue="Code"
                   style="max-width:300px;">                
        </ng-select>
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="margin-bottom: 5px;">
        <label style="font-size:.8em;">Serial Number</label><br />
        <input type="text" class="form-control" [(ngModel)]="formData.SerialNumber" style="max-width:300px;" maxlength="60" />
    </div>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <label style="font-size:.8em;">Active</label><br />
        <input type="checkbox" [(ngModel)]="formData.Active" style="max-width:300px;width: 30px;height: 30px;" [disabled]="true" />
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-text-success" (click)="addServiceItemAndClose()" [disabled]="formData.SMTypeID == null || formData.ServiceItem == null || formData.ServiceItem == ''">Create</button>
</div>